import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getProducts } from "../api/productService";
import ProductCard from "../components/ProductCard";
import "./Home.css";

const Home = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadProducts = async () => {
      try {
        const data = await getProducts();

        setProducts(data);
      } catch (error) {
        console.error("Homepage product loading error:", error);

        setError("Unable to load products. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    loadProducts();
  }, []);

  const featuredProducts = products.slice(0, 8);

  return (
    <main className="home-page">
      {/* HERO */}

      <section className="luxury-hero">
        <div className="hero-overlay"></div>

        <div className="hero-decoration hero-decoration-one">✦</div>

        <div className="hero-decoration hero-decoration-two">✧</div>

        <div className="hero-content">
          <p className="hero-eyebrow">THE STAR GOLD COLLECTION</p>

          <h1>
            Jewellery
            <br />
            <span>That Makes You Shine</span>
          </h1>

          <p className="hero-description">
            Discover elegant covering jewellery and imitation jewellery crafted
            to make every occasion unforgettable.
          </p>

          <div className="hero-buttons">
            <Link to="/collections" className="hero-primary-button">
              Explore Collection
            </Link>

            <Link to="/contact" className="hero-secondary-button">
              Visit STAR GOLD
            </Link>
          </div>
        </div>

        <div className="hero-bottom-label">
          <span>SCROLL TO DISCOVER</span>
          <span className="hero-line"></span>
        </div>
      </section>

      {/* INTRO */}

      <section className="home-intro">
        <div className="intro-small">OUR STORY</div>

        <h2>
          Elegance Beyond
          <br />
          <span>Ordinary</span>
        </h2>

        <p>
          At STAR GOLD, we bring together timeless elegance and modern style.
          Discover jewellery designed to complement your celebrations, special
          moments and everyday beauty.
        </p>

        <Link to="/collections" className="text-link">
          Discover Our Collection
          <span>→</span>
        </Link>
      </section>

      {/* FEATURED PRODUCTS */}

      <section className="home-products">
        <div className="section-heading">
          <p>CURATED FOR YOU</p>

          <h2>Featured Jewellery</h2>

          <span>Discover pieces selected from our latest collection.</span>
        </div>

        {loading && (
          <div className="products-message">
            <p>Loading products...</p>
          </div>
        )}

        {!loading && error && (
          <div className="products-message error">
            <p>{error}</p>
          </div>
        )}

        {!loading && !error && featuredProducts.length === 0 && (
          <div className="products-message">
            <p>No products available yet.</p>
          </div>
        )}

        {!loading && !error && featuredProducts.length > 0 && (
          <div className="products-grid">
            {featuredProducts.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        )}

        {!loading && !error && products.length > 8 && (
          <div className="products-view-all">
            <Link to="/collections" className="outline-gold-button">
              View All Jewellery
            </Link>
          </div>
        )}
      </section>

      {/* COLLECTION CTA */}

      <section className="collection-banner">
        <div className="collection-banner-content">
          <p>TIMELESS BEAUTY</p>

          <h2>
            Find Your
            <br />
            Signature Shine
          </h2>

          <span>
            Jewellery for every celebration, every occasion and every you.
          </span>

          <Link to="/collections" className="hero-primary-button">
            Shop Collection
          </Link>
        </div>
      </section>

      {/* TRUST SECTION */}

      <section className="home-features">
        <div className="home-feature">
          <div className="feature-icon">✦</div>

          <h3>Elegant Designs</h3>

          <p>Carefully selected jewellery for every occasion.</p>
        </div>

        <div className="home-feature">
          <div className="feature-icon">◇</div>

          <h3>Quality Collection</h3>

          <p>Beautiful pieces made to complete your look.</p>
        </div>

        <div className="home-feature">
          <div className="feature-icon">♡</div>

          <h3>Personal Service</h3>

          <p>Connect with STAR GOLD whenever you need us.</p>
        </div>
      </section>
    </main>
  );
};

export default Home;
